import React, { useEffect, useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { adminApi } from '../../api';

import LimitForm from './LimitForm';

export default function AdminLimitOverride({ t, setAlert, env }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [loaded, setLoaded] = useState(false);
  const [limit, setLimit] = useState({});
  const [initialValues, setInitialValues] = useState({});

  const mapInitialValues = (incomingLimit = limit) => {
    return {
      provider_name: incomingLimit.provider_name,
      app_handle: incomingLimit.app_handle,
      transaction_graph_labels: incomingLimit.transaction_graph_labels,
      user_category: incomingLimit.user_category,
      duration: incomingLimit.duration,
      amount: incomingLimit.amount,
      begins_at: incomingLimit.begins_at,
      limit_type: incomingLimit.limit_type,
      expires_at: incomingLimit.expires_at,
      expires_after_count: incomingLimit.expires_after_count,
    };
  };

  const createLimitValues = {
    name: '',
    provider_name: '',
    app_handle: '',
    transaction_graph_labels: [],
    user_category: '',
    duration: '',
    amount: '',
    begins_at: '',
    limit_type: '',
    expires_at: '',
    expires_after_count: '',
  };

  const getLimit = async (limit_id = id) => {
    setLoaded(false);

    try {
      const response = await adminApi.fetchLimitOverride(limit_id);
      setLimit(response.limit);
      const newInitialValues = mapInitialValues(response.limit);
      setInitialValues(newInitialValues);
      setLoaded(true);
    } catch (error) {
      setAlert({ message: error, variant: 'warning' });
      navigate('/admin/limit_overrides');
    }
  };

  const handleUpdate = async (values) => {
    const changedValues = {};
    Object.keys(values).forEach((key) => {
      if (values[key] === null && values[key] !== initialValues[key]) {
        changedValues[key] = values[key];
      } else if (values[key] === '') {
        changedValues[key] = null;
      } else if (values[key] !== initialValues[key]) {
        changedValues[key] = values[key];
      }
    });

    setLoaded(false);
    try {
      const response = await adminApi.updateLimitOverride(limit.uuid, changedValues, initialValues);
      setLimit(response.limit);
      const newInitialValues = mapInitialValues(response.limit);
      setAlert({ message: response.message, variant: 'success' });
      setInitialValues(newInitialValues);
    } catch (error) {
      setAlert({ message: error, variant: 'warning' });
    }
    setLoaded(true);
  };

  const handleCreate = async (values) => {
    setLoaded(false);
    try {
      const response = await adminApi.createLimitOverride(values);
      setLimit(response.limit);
      setAlert({ message: response.message, variant: 'success' });
      const newInitialValues = mapInitialValues(response.limit);
      setInitialValues(newInitialValues);
      navigate({
        pathname: `/admin/limit_override/${response.limit.uuid}/detail`,
        state: { from: location.pathname },
        replace: true,
      });
    } catch (error) {
      setAlert({ message: error, variant: 'warning' });
      setInitialValues(values);
    }
    setLoaded(true);
  };

  const handleDelete = async () => {
    try {
      const response = await adminApi.deleteLimitOverride(limit.uuid);
      setAlert({ message: response.message, variant: 'success' });
      navigate(-1);
    } catch (error) {
      setAlert({ message: error, variant: 'warning' });
    }
  };

  useEffect(() => {
    if (id !== 'new') {
      getLimit();
    } else {
      setInitialValues(createLimitValues);
      setLoaded(true);
    }
  }, [env]);
  return (
    <>
      {id !== 'new' && (
        <LimitForm
          t={t}
          title={t('admin.limits.titleOverrideSingle')}
          limit={limit}
          handleDelete={handleDelete}
          onSubmit={handleUpdate}
          loaded={loaded}
          initialValues={initialValues}
          uneditedValues={mapInitialValues()}
          isCreate={false}
          isLimitOverride
        />
      )}
      {id === 'new' && (
        <LimitForm
          t={t}
          title={t('admin.limits.createOverride.title')}
          limit={createLimitValues}
          handleDelete={handleDelete}
          onSubmit={handleCreate}
          loaded={loaded}
          initialValues={initialValues}
          uneditedValues={initialValues}
          isLimitOverride
        />
      )}
    </>
  );
}
